import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ReportRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { canViewAllReports } = useAuth();
  return canViewAllReports ? <>{children}</> : <Navigate to="/dashboard" replace />;
};

export default ReportRoute;
